module.exports = __webpack_public_path__ + "fonts/effect-advanced-idea-mechanics-1b2b94.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/effect-advanced-idea-mechanics.svg
// module id = 704
// module chunks = 0